import React, { FC } from 'react';

import { List, ListItem, ListItemText } from '@mui/material';

import styles from './StringList.module.scss';

interface StringListProps {
  header: string;
  details: string[];
}

const StringList: FC<StringListProps> = ({header, details}) => {
  return (
    <div className={styles.StringList} data-testid="StringList">
      <header className={styles.stringListHeader}>{header}</header>
      <List dense disablePadding className={styles.stringListContent}>
        { details &&
          details.map((detail: string, index: number) => {
            return (
              <ListItem key={index} disablePadding>
                <ListItemText primary={detail}/>
              </ListItem>
            )
          })
        }
      </List>
      <footer className={styles.stringListFooter}></footer>

    </div>
  );
}

export default StringList;
